import { ThemeName } from './themeName';
import { Colors } from '@/types/pageContract';

export const themes: Record<string, Colors> = {
  'theme-default': {
    base1: '#29459E',
    base2: '#3457C6',
    background: '#F8F8F8',
    contrast: '#DDDDDD',
    text: '#333333',
    light: false,
    title: 'theme-default'
  },
  'theme-dark': {
    base1: '#888888',
    base2: '#888888',
    background: '#444444',
    contrast: '#333333',
    text: '#ffffff',
    light: false,
    title: 'theme-dark'
  }
};

// Modify this function to translate from a Systime theme to a Vuetify theme!
export function systimeThemeToVuetify(theme: Colors) {
  return {
    primary: theme.base1,
    secondary: theme.base2,
    accent: theme.contrast,
    success: theme.base1,
    info: theme.text,
    warning: theme.base2,
    error: '#EB152E', // We hardcode this value, because it never needs to change anyway
    // customized props start here
    background: theme.background,
    text: theme.text
  };
}

export function themeForName(themeName: ThemeName) {
  return systimeThemeToVuetify(themes[themeName]);
}
